<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/fireLedger/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="title" label="标题">
          <el-input clearable v-model="searchForm.title" placeholder="请输入标题" />

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="标题" prop="title"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="说明" prop="description">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/fireLedger/detail?ledgerId=' + row.ledgerId )">详情</el-button>
              <el-button type="text" v-if="hasEdit"
              @click="$router.push('/fireLedger/edit?ledgerId=' + row.ledgerId)">编辑</el-button>

            <el-button v-if="hasDel" type="text" @click="deleteRow(row.ledgerId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'fireLedger',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        title: null
      }

    }
  },
  computed: {

    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  watch: {
    '$route.query'(newV) {
      this.resetForm()
    }
  },
  created() {
    this.loadData()
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.fireLedger.selectPaFireLedgerByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          issueType: this.pointType
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        title: null

      }
      this.onSearch()
    },
    deleteRow(ledgerId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.fireLedger.deletePaFireLedger, {
          ledgerId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
